import { forwardRef } from 'react';

function joinClasses(...parts) {
  return parts.filter(Boolean).join(' ');
}

/** Multi-line variant of {@link TextInput} — same glass tokens and focus ring. */
const TextArea = forwardRef(function TextArea({ className = '', invalid = false, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      className={joinClasses(
        'text-input text-input--textarea',
        invalid && 'text-input--invalid',
        className,
      )}
      {...props}
    />
  );
});

export default TextArea;
